// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__bKVHC","featureSection":"style_featureSection__VOFyI","activeMark":"style_activeMark__21Q27","button":"style_button__LAt8M"};